import styled, { CSSProperties } from 'styled-components';
import { AppTheme } from '../../src/styles/theme';

type Props = {
  color?: keyof AppTheme['fontColors'];
  size?: keyof AppTheme['fontSizes'];
  notdot?: boolean;
};

const Item = styled.li<Props>`
  display: flex;
  margin: 0;
  padding: ${({ theme }) => theme.spaces.s};

  &:before {
    content: ${({ notdot }) => (notdot ? 'initial' : '"・"')};
  }
`;

const Root = styled.ul<Props>`
  margin: 0;
  padding: 0;
  list-style: none;
  color: ${({ theme, color }) =>
    color ? theme.fontColors[color] : theme.fontColors.default};

  & > ${Item} {
    font-size: ${({ theme, size }) => size && theme.fontSizes[size]};

    &:before {
      font-size: ${({ theme, size }) => size && theme.fontSizes[size]};
    }
  }
`;

export const List = Object.assign(Root, { Item });
